module.exports = __webpack_public_path__ + "img/homePad_logo_light_10years.3ceb7a6e.svg";